import React, { Component } from 'react'
import { KeyboardDateTimePicker as DTPicker } from '@material-ui/pickers';

export class DateTimePicker extends Component{

  handleChange = date => {
    this.props.onChange({
      target: {
        value: date ? date.format('YYYY-MM-DD HH:mm:ssZ') : date
      }
    })
  }

  get value(){
    return this.props.value ? new Date(this.props.value) : null
  }

  openOnFocus = () =>{
    if(this._picker && !this.value){
      this._picker.wrapper.open()
      this._picker = null
    }
  }

  render = () =>
    <DTPicker
      format="DD/MM/YYYY HH:mm"
      ampm={false}
      {...this.props}
      pickerRef={_picker => this._picker = _picker}
      onChange={this.handleChange}
      value={this.value}
      onFocus={this.openOnFocus}
    />

}

export default DateTimePicker